var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup406(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#486a41}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    transform: "translate(-46 -384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_646",
    fill: "none",
    d: "M0 0H50V50H0z",
    transform: "translate(46 384)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_002-customer",
    transform: "translate(51.172 392.621)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_81",
    cx: 6.587,
    cy: 6.587,
    r: 6.587,
    className: "cls-2",
    transform: "translate(13.239)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_82",
    cx: 4.296,
    cy: 4.009,
    className: "cls-2",
    rx: 4.296,
    ry: 4.009,
    transform: "translate(29.277 5.155)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_83",
    cx: 4.296,
    cy: 4.009,
    className: "cls-2",
    rx: 4.296,
    ry: 4.009,
    transform: "translate(1.784 5.155)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    d: "M10.358 241.724c-1.671-1.369-3.185-1.188-5.117-1.188A5.231 5.231 0 0 0 0 245.745v8.43a2.268 2.268 0 0 0 2.27 2.262c5.405 0 4.754.1 4.754-.233 0-5.974-.707-10.354 3.334-14.48z",
    className: "cls-2",
    transform: "translate(0 -224.481)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    d: "M132.506 239.941c-3.375-.282-6.308 0-8.839 2.092-4.234 3.392-3.419 7.958-3.419 13.545a2.708 2.708 0 0 0 2.7 2.7c16.293 0 16.941.526 17.908-1.614.317-.724.23-.494.23-7.415.002-5.495-4.758-9.308-8.58-9.308z",
    className: "cls-2",
    transform: "translate(-110.908 -223.855)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    d: "M382.927 240.537c-1.943 0-3.448-.179-5.117 1.188 4.011 4.1 3.334 8.177 3.334 14.48 0 .333-.54.233 4.673.233a2.349 2.349 0 0 0 2.351-2.342v-8.349a5.231 5.231 0 0 0-5.241-5.21z",
    className: "cls-2",
    transform: "translate(-348.648 -224.482)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup406);
export default __webpack_public_path__ + "static/media/Group 406.85c7c0f0df5139d478b4c58e6b4884bd.svg";
export { ForwardRef as ReactComponent };